export const env = {
  url: process.env.URL,
  shopifyShopName: process.env.GATSBY_SHOPIFY_SHOP_NAME,
  shopifyMultipassSecret: process.env.GATSBY_SHOPIFY_MULTIPASS_SECRET,
  googleSiteVerification: `JTRJjYKugiQEG1Q5NrzcNCfhbIv-yfwECVjuGT-e0xM`,
  cylindoAccountId: Number(process.env.GATSBY_CYLINDO_ACCOUNT_ID),
}
